import { Session, SupabaseClient, User } from '@supabase/supabase-js'
import { createContext } from 'react'

export const GlobalContext = createContext<GlobalContextType>({
    session:null,
    user:null,

    setSession:(session:Session) => {console.log("setSession function not set")},
    setUser:(user:User) => {console.log("setUser function not set.")}
})

export type GlobalContextType = {
    session:Session|null,
    user:User|null

    setSession(session:Session|null):void,
    setUser(user:User|null):void
}